import * as React from "react";
import { cardContainer, cardContainerRemoving } from "./asCard.styles";
import { IRemoveCard, IRemoveCallback, TRemoveCardArgs, TTrackingData } from "./asCard.d";

// note: this HOC hijacks a removeCard prop
export function asCard<P extends IRemoveCard>(
  Component: React.ComponentClass<P> | React.FunctionComponent<P>,
): React.ComponentClass<P> {
  return class ChromeFeedCard extends React.Component<P, { isPendingRemoval: boolean }> {
    private removalTimeout: ReturnType<typeof setTimeout>;

    constructor(props: P & IRemoveCard) {
      super(props);
      this.state = {
        isPendingRemoval: false,
      };
    }

    // ~-~-~-~-~-~-~-
    // Life-Cycle
    // ~-~-~-~-~-~-~-
    public componentWillUnmount() {
      // be a good JS engineer
      this.clearTimeouts();
    }

    // ~-~-~-~-~-~-~-
    // Removal Animations
    // ~-~-~-~-~-~-~-
    // crazy animations...
    private delayedRemove: IRemoveCallback = (args, trackingData) => {
      this.removalTimeout = setTimeout(
        () => this.props.removeCard && this.props.removeCard(args, trackingData),
        500,
      );
    };

    private clearTimeouts = () => {
      clearTimeout(this.removalTimeout);
    };

    private startRemoval: IRemoveCallback = (args, trackingData) => {
      const { removeCard } = this.props;
      if (removeCard && args && args.isSynchronous) {
        removeCard(args, trackingData);
      } else if (removeCard) {
        this.setState({ isPendingRemoval: true }, () => this.delayedRemove(args, trackingData));
      }
    };

    // ~-~-~-~-~-~-~-
    // Render
    // ~-~-~-~-~-~-~-
    public render() {
      const { isPendingRemoval } = this.state;

      return (
        <div style={isPendingRemoval ? cardContainerRemoving : cardContainer}>
          <Component
            {...this.props}
            removeCard={(args?: TRemoveCardArgs, trackingData?: TTrackingData) =>
              this.startRemoval(args, trackingData)
            }
          />
        </div>
      );
    }
  };
}
